module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AkOETIz44oaVgAAAG5JREFUKM+Vy7ENg0AMQNEXCYk2CzACQ2SdtKzBHIzBEIwAA9BSQRoXRHHQ8SVLJ58fDDhuzgBPzDfQHAa8sBegPW6/6gtgL6nGdIGmuElrsSVoi7/LugR2CnpgPKExdkU1WGOa7KD6Axe8T++fPggXRz3OvNwSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/images/arrow_down.png
// module id = 1548
// module chunks = 1